import { Instagram, Mail, Shell } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <div className="footer-main container-wide">
        <Link to="/" className="footer-logo"><img src="/assets/logo-site.jpg" alt="Vague de Mots" /></Link>
        <div className="footer-column">
          <h3>Navigation</h3>
          <Link to="/">Accueil</Link><Link to="/prestations">Prestations</Link><Link to="/presentation">Présentation</Link><Link to="/tarifs">Tarifs</Link><Link to="/contact">Contact</Link>
        </div>
        <div className="footer-column footer-contact">
          <h3>Contact</h3>
          <a href="mailto:vaguedemots.services@gmail.com"><Mail size={20} /> <span>vaguedemots.services@gmail.com</span></a>
          <a href="https://www.instagram.com/vague_demots/" target="_blank" rel="noreferrer"><Instagram size={20} /> <span>@vague_demots</span></a>
        </div>
        <blockquote className="footer-quote">
          <span className="quote-mark">“</span>
          Les mots sont des vagues :<br />parfois ils bousculent, parfois ils apaisent,<br />mais ils laissent toujours une empreinte.
          <Shell size={28} strokeWidth={1.3} />
        </blockquote>
      </div>
      <div className="footer-legal">
        <span>© {new Date().getFullYear()} Vague de Mots — Lectrice-correctrice</span><i />
        <span>Tous droits réservés</span><i />
        <Link to="/mentions-legales">Mentions légales</Link><i />
        <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>
      </div>
    </footer>
  );
}
